module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAhCAYAAAC4JqlRAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADRSURBVHgB7ZaxDcIwEEXPxEKsQOcVGIENoGQKGIUtUoAUNkhJAVJWcIHIChQXDqeiQsrZv0L3JHe2/vuyTzKRYRiGkuf9vO+7JhCImWbz43Y6vEmOzNyiJFQCFfNFnETnKKAkHCnpr3XgedU6cUGEovd+vVxtI2WiFkBLZAkgJbIFUBJFAgiJYoFSCdUY/mZB3y6S1mvyScAVNKk9p/aU2ktqP6T2uzj1fOEjLAsvEkCEZwugwrMEkOFqAXT4iGoMB88bZHgW45+g7+pAhmH8Cx+wrbg0f0fFyQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-y2.png
// module id = uGp7
// module chunks = 1